import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentAdminComponent } from './equipment-admin/equipment-admin.component';
import { EquipmentAdminWidgetComponent } from './equipment-admin-widget/equipment-admin-widget.component';
import { CommonLayoutModule, CommonUIFieldsModule, PagedContentModule, CommonUIModule, CommonUITableModule, CommonUIButtonsModule, CommonUIFormularModule, CommonUIDetailLayoutModule } from '@sdbn/common';
import { EquipmentAdminAttributesComponent } from './equipment-admin/equipment-admin-attributes/equipment-admin-attributes.component';
import { EquipmentAdminInstancesComponent } from './equipment-admin/equipment-admin-instances/equipment-admin-instances.component';
import { EquipmentAdminDetailsComponent } from './equipment-admin/equipment-admin-details/equipment-admin-details.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    EquipmentAdminComponent,
    EquipmentAdminWidgetComponent,
    EquipmentAdminAttributesComponent,
    EquipmentAdminInstancesComponent,
    EquipmentAdminDetailsComponent
  ],
  imports: [
    CommonModule,
    PagedContentModule,
    CommonLayoutModule,
    CommonUIFieldsModule,
    CommonUIModule,
    CommonUITableModule,
    CommonUIButtonsModule,
    CommonUIFormularModule,
    CommonUIDetailLayoutModule,
    ReactiveFormsModule
]
})
export class EquipmentAdminModule { }
